import { useTheme } from 'next-themes';
import { useMounted } from '@/hooks/mounted.hook';
import LoadingGif from '@/assets/images/loading.gif';
import LoadingDarkGif from '@/assets/images/loading-dark.gif';

/**
 * Custom hook để lấy loading gif phù hợp với theme hiện tại
 * @returns loading gif URL dựa trên theme (dark/light)
 */
export function useLoadingGif() {
  const mounted = useMounted();
  const { theme } = useTheme();

  // Nếu chưa mount, trả về loading.gif mặc định để tránh flash
  if (!mounted) {
    return LoadingGif;
  }

  // Nếu theme là dark thì dùng loading-dark.gif, ngược lại dùng loading.gif
  return theme === 'dark' ? LoadingDarkGif : LoadingGif;
}
